export type RequestKind='chat'|'list'|'messages'|'events'|'readers'|'request';
export type CompletedRequest={kind:RequestKind;elapsedMs:number;serverMs?:number;status?:number};
export type ConnectionProblem={state:'slow'|'timeout'|'server'|'unreachable'|'offline';kind:RequestKind;stage:'headers'|'body';elapsedMs:number;serverMs?:number;status?:number};
export function requestKind(path:string):RequestKind {
 const pathname=path.split('?')[0]!;
 if(/^\/v1\/conversations\/[^/]+\/events$/.test(pathname))return 'events';
 if(/^\/v1\/conversations\/[^/]+\/read-cursors$/.test(pathname))return 'readers';
 return /^\/v1\/conversations\/[^/]+\/messages(?:\/|$)/.test(pathname)?'messages':/^\/v1\/conversations\/[^/]+$/.test(pathname)?'chat':pathname==='/v1/conversations'?'list':'request';
}
export class ConnectionHealth {
 private next=0;
 private pending=new Map<number,{kind:RequestKind;started:number;headersAt?:number;serverMs?:number;status?:number}>();
 private problem:{value:ConnectionProblem;at:number;id:number}|null=null;
 get pendingCount(){return this.pending.size;}
 begin(kind:RequestKind,now:number):number {
  const id=++this.next;this.pending.set(id,{kind,started:now});
  if(this.pending.size>32)this.pending.delete(this.pending.keys().next().value!);return id;
 }
 headers(id:number,now:number,status:number,timing:string|null):void {
  const entry=this.pending.get(id);if(!entry)return;
  entry.headersAt=now;entry.status=status;
  const match=/(?:^|,)\s*app;dur=(\d+(?:\.\d+)?)\s*(?:,|$)/.exec(timing??'');
  const duration=match?Number(match[1]):NaN;if(Number.isFinite(duration)&&duration<=600000)entry.serverMs=duration;
 }
 finish(id:number,now:number,error?:unknown,cancelled=false):CompletedRequest|null {
  const entry=this.pending.get(id);this.pending.delete(id);if(!entry||cancelled)return null;
  const e=error as {code?:string;status?:number}|undefined;
  if(error){
   const status=e?.status??entry.status;
   const state=e?.code==='REQUEST_TIMEOUT'?'timeout':status&&status>=500?'server':'unreachable';
   // Authorization/validation refusals describe access or input, not bad connectivity.
   if(status&&status<500&&e?.code!=='REQUEST_TIMEOUT')return null;
   this.problem={id,at:now,value:{state,kind:entry.kind,stage:entry.headersAt===undefined?'headers':'body',elapsedMs:now-entry.started,serverMs:entry.serverMs,status}};
  }else{
   if(this.problem&&id>this.problem.id&&entry.kind===this.problem.value.kind)this.problem=null;
   if(now-entry.started>=3000)return {kind:entry.kind,elapsedMs:now-entry.started,serverMs:entry.serverMs,status:entry.status};
  }
  return null;
 }
 snapshot(now:number,online:boolean):ConnectionProblem|null {
  if(!online)return {state:'offline',kind:'request',stage:'headers',elapsedMs:0};
  if(this.problem&&now-this.problem.at>=30000)this.problem=null;
  const slow=[...this.pending.values()].filter(e=>now-e.started>=3000).at(-1);
  if(slow)return {state:'slow',kind:slow.kind,stage:slow.headersAt===undefined?'headers':'body',elapsedMs:now-slow.started,serverMs:slow.serverMs,status:slow.status};
  return this.problem?.value??null;
 }
 reset(){this.pending.clear();this.problem=null;}
}
